import type { NewsType } from '@/stores/useNewsAdminStore'

/** Libellés et couleurs partagés (admin, modal, fil d'actualité). */

export const NEWS_TYPE_LABELS: Record<NewsType, string> = {
  CHANGELOG: 'Changelog',
  FEATURE: 'Nouveauté',
  INFO: 'Information',
  ALERT: 'Alerte',
}

export const NEWS_TYPE_BADGES: Record<NewsType, string> = {
  CHANGELOG: 'badge-primary',
  FEATURE: 'badge-accent',
  INFO: 'badge-info',
  ALERT: 'badge-error',
}
